export const globals = {
  standardActivatedLanguage: 'en',
  standardActivatedArchiveLanguage: 'de',
  standardActivatedVoiceLanguage: 'de-DE',
  standardActivatedTranslationLanguage: 'en',
  standardBibleId: 'de4e12af7f28f599-01'
};
